import { Button, ButtonProps } from "antd";
import React from "react";

interface FormBuilderSaveButtonProps extends ButtonProps {
	form: any;
	labelText?: string;
	disabled?: boolean;
	handleFormSave?: (data: any) => void;
}

const FormBuilderSaveButton = React.forwardRef<
	HTMLButtonElement,
	FormBuilderSaveButtonProps
>((props, ref) => {
	return (
		<Button
			ref={ref}
			{...props}
			type={props.type || "primary"}
			htmlType="submit"
			{...(props.handleFormSave && { onClick: props.handleFormSave })}
			disabled={
				props.disabled ?? (!props.form.isValidated || !props.form.isDirty)
			}
		>
			{props.labelText || "Save"}
		</Button>
	);
});

export default FormBuilderSaveButton;
